/**
* DevExpress Dashboard (chart-indicators-extension.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { extensionNameMap } from '../../common/control-options';
const name = 'chartIndicators';
const nameAlias = 'chart-indicators';
export class ChartIndicatorsExtension {
    get customChartIndicators() {
        return this.options?.customIndicatorTypes;
    }
    constructor(dashboardControl, options) {
        this.dashboardControl = dashboardControl;
        this.options = options;
        this.name = name;
    }
}
extensionNameMap[nameAlias] = name;
